import type { FaqItem } from "@/lib/faq-jsonld";

interface FaqAccordionProps {
  /** Zichtbare kop boven de accordeon */
  title?: string;
  /** Optionele intro-tekst onder de kop */
  intro?: string;
  /** FAQ-items — moeten 1-op-1 matchen met de FAQPage JSON-LD */
  items: FaqItem[];
  /** id voor het section-element (deep-link en aria-labelledby) */
  id?: string;
}

/**
 * Zichtbare FAQ-accordeon die 1-op-1 matcht met de FAQPage JSON-LD.
 * Google vereist dat FAQ-antwoorden zichtbaar op de pagina staan voor
 * rich results — gebruik altijd dezelfde items voor JSON-LD én weergave.
 */
export function FaqAccordion({
  title = "Veelgestelde vragen",
  intro,
  items,
  id = "faq",
}: FaqAccordionProps) {
  return (
    <section aria-labelledby={`${id}-title`} className="mt-16">
      <div className="mx-auto max-w-3xl">
        <h2
          id={`${id}-title`}
          className="text-center text-2xl font-bold tracking-tight text-foreground sm:text-3xl"
        >
          {title}
        </h2>
        {intro ? (
          <p className="mx-auto mt-2 max-w-xl text-center text-sm text-foreground/70">
            {intro}
          </p>
        ) : null}

        <dl className="mt-8 divide-y divide-border rounded-2xl border border-border bg-card">
          {items.map((f) => (
            <details key={f.q} className="group px-5 py-4 open:bg-muted/30">
              <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left text-sm font-semibold text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">
                <dt>{f.q}</dt>
                <span
                  aria-hidden="true"
                  className="text-orange transition-transform group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <dd className="mt-3 text-sm leading-relaxed text-foreground/75">
                {f.a}
              </dd>
            </details>
          ))}
        </dl>
      </div>
    </section>
  );
}
